// This controller will initialize Chozen behavior on select inputs
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Activate chosen select
    $(this.element).chosen();
  }
}
